export interface CampaignEmail {
  id: number
  subject: string
  html: string
  createdAt?: string
  updatedAt?: string
}

export interface CreateCampaignEmailPayload {
  subject: string
  html: string
}

export interface CreateCampaignEmailResponse {
  campaignEmail: CampaignEmail
}

export interface UpdateCampaignEmailPayload {
  subject?: string
  html?: string
}

export interface UpdateCampaignEmailData {
  id: number
  payload: UpdateCampaignEmailPayload
}

export interface UpdateCampaignEmailResponse {
  campaignEmail: CampaignEmail
}

export const CAMPAIGN_EMAIL_SUBJECT_MAX_LENGTH = 150
export const CAMPAIGN_EMAIL_HTML_MAX_LENGTH = 512000
